import React, { useState, useEffect } from "react";
import {
	Card,
	Button,
	ToggleButton,
	ToggleButtonGroup,
	Col,
	Form,
	Row,
} from "react-bootstrap";
import { FaSearch, FaUsers } from "react-icons/fa";
import { LuDot } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import LeagueCard from "./Leagues/LeagueCard";
import "../../../App.css";
import { IoSearch } from "react-icons/io5";
import ViewLeagueCard from "./Leagues/ViewLeagueCard";

const LeaguesComponent = ({ userLeagues, allLeagues, sports, series }) => {
	const navigate = useNavigate();

	const [toggleValue, setToggleValue] = useState(
		userLeagues.length > 0 ? "myLeagues" : "allLeagues",
	);

	const [searchQuery, setSearchQuery] = useState("");
	const [sortOrder, setSortOrder] = useState("asc"); // asc or desc
	const [filterSeries, setFilterSeries] = useState("");
	const [filterSport, setFilterSport] = useState("");
	const [visibleLeagues, setVisibleLeagues] = useState(5);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

	const filteredLeagues = (
		toggleValue === "myLeagues" ? userLeagues : allLeagues
	)
		.filter((league) => {
			return (
				league.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
				(filterSeries ? league.series.name === filterSeries : true) &&
				(filterSport ? league.sport.name === filterSport : true)
			);
		})
		.sort((a, b) => {
			if (a.featured && !b.featured) return -1;
			if (!a.featured && b.featured) return 1;
			if (sortOrder === "asc") {
				return a.name.localeCompare(b.name);
			} else {
				return b.name.localeCompare(a.name);
			}
		});

	useEffect(() => {
		if (userLeagues.length > 0) {
			setToggleValue("myLeagues");
		} else {
			setToggleValue("allLeagues");
		}
	}, [userLeagues]);

	const handleToggleChange = (value) => {
		setToggleValue(value);
	};

	const handleShowMore = () => {
		setVisibleLeagues((prevVisible) => prevVisible + 10);
	};

	const handleViewLeague = (leagueId) => {
		navigate(`/league/${leagueId}`);
	};

	return (
		<div className="mx-sm-4 mt-5">
			<div className="d-flex flex-row justify-content-center mb-3">
				{userLeagues?.length > 0 ? (
					<ToggleButtonGroup
						type="radio"
						name="leagueToggle"
						value={toggleValue}
						onChange={handleToggleChange}
						className="mb-3"
					>
						<ToggleButton id="myLeagues" value="myLeagues" variant="dark">
							My Leagues
						</ToggleButton>
						<ToggleButton id="allLeagues" value="allLeagues" variant="dark">
							All Leagues
						</ToggleButton>
					</ToggleButtonGroup>
				) : (
					<Card className="bg-secondary px-4 rounded-2 text-white fs-5 py-2 fw-bold">
						Leagues
					</Card>
				)}
			</div>
			<div className="mb-4">
				<Row className="g-3 mx-2">
					<Col md>
						<div className="position-relative">
							<Form.Control
								type="text"
								placeholder="Search leagues..."
								placeholderTextColor="white"
								value={searchQuery}
								className="border-0 bg-secondary text-white custom-input custom-placeholder"
								onChange={(e) => setSearchQuery(e.target.value)}
							/>
							<IoSearch
								className="position-absolute top-50 end-0 translate-middle-y me-3 text-white"
							/>
						</div>
					</Col>
					<Col md>
						<Form.Select
							value={filterSeries}
							onChange={(e) => setFilterSeries(e.target.value)}
							className="border-0 bg-secondary text-white"
						>
							<option value="">Filter by Series</option>
							{Array.isArray(series) &&
								series.map((series) => (
									<option key={series._id} value={series.name}>
										{series.name}
									</option>
								))}
						</Form.Select>
					</Col>
					<Col md>
						<Form.Select
							value={filterSport}
							onChange={(e) => setFilterSport(e.target.value)}
							className="border-0 bg-secondary text-white"
						>
							<option value="">Filter by Sport</option>
							{Array.isArray(sports) &&
								sports.map((sport) => (
									<option key={sport._id} value={sport.name}>
										{sport.name}
									</option>
								))}
						</Form.Select>
					</Col>
					<Col md>
						<Form.Select
							value={sortOrder}
							onChange={(e) => setSortOrder(e.target.value)}
							className="border-0 bg-secondary text-white"
						>
							<option value="asc">Sort A-Z</option>
							<option value="desc">Sort Z-A</option>
						</Form.Select>
					</Col>
				</Row>
			</div>
			<div>
				{toggleValue === "myLeagues" && (
					<div className="pb-4">
						{filteredLeagues.slice(0, visibleLeagues).map((league) => (
							<ViewLeagueCard
								key={league._id}
								league={league}
								onViewLeague={handleViewLeague}
							/>
						))}
					</div>
				)}

				{toggleValue === "allLeagues" && (
					<div className="pb-4">
						{filteredLeagues.slice(0, visibleLeagues).map((league) => (
							<ViewLeagueCard
								key={league._id}
								league={league}
								onViewLeague={handleViewLeague}
							/>
						))}
					</div>
				)}
				<div className="d-flex flex-row justify-content-center mb-3">
					{filteredLeagues.length > visibleLeagues && (
						<Button variant="outline-success" onClick={handleShowMore}>
							Show 10 More
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default LeaguesComponent;
